<template>
	<div class="machine-profit">
		<div class="search-user-profit">
			<div class="el-search vue-top-padding radius">
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form
							ref="WarnStatistics"
							:model="search"
							:inline="true"
							label-width="10px"
							size="small"
							class="demo-form-inline el-input-height"
							style="float: right">
							<el-form-item prop="dateTime">
							<el-date-picker
								v-model="dateTime"
								type="datetimerange"
								format="yyyy-MM-dd HH:mm:ss"
								value-format="yyyy-MM-dd HH:mm:ss"
								range-separator="-"
								:default-time="['00:00:00', '23:59:59']"
								:start-placeholder="$t('searchOrder.start')"
								:end-placeholder="$t('searchOrder.end')">
							</el-date-picker>
							</el-form-item>
							<el-form-item>
								<el-input
									v-model="search.userName"
									:placeholder="$t('searchUserProfit.userName')"></el-input>
							</el-form-item>
							<el-form-item>
								<el-input
									v-model="search.nickName"
									:placeholder="$t('searchUserProfit.nickName')"></el-input>
							</el-form-item>
							<el-form-item>
								<el-input
									v-model="search.equipmentNo"
									:placeholder="$t('searchUserProfit.equipmentNo')"></el-input>
							</el-form-item>
							<el-form-item>
								<el-input
									v-model="search.equipmentName"
									:placeholder="
										$t('searchUserProfit.equipmentName')
									"></el-input>
							</el-form-item>
							<el-form-item>
								<el-input
									v-model="search.code"
									:placeholder="$t('searchUserProfit.alarmCode')"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button
									type="primary"
									@click="onSubmit"
									icon="el-icon-search"
									>{{ $t("common.search") }}</el-button
								>
								<el-button
									@click="resetSearch('WarnStatistics')"
									icon="el-icon-refresh"
									>{{ $t("common.reset") }}</el-button
								>
							</el-form-item>
						</el-form>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="AdverStatisticsList"
				style="width: 100%"
				max-height="638"
				:border="true">
				<el-table-column
					prop="userName"
					:show-overflow-tooltip="true"
					:label="$t('machineOrder.userName')"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="nickName"
					:show-overflow-tooltip="true"
					:label="$t('machineOrder.nickName')"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="equipmentNo"
					:label="$t('machineOrder.equipmentNo')"
					:show-overflow-tooltip="true"
					:width="180"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="equipmentName"
					:label="$t('machineOrder.equipmentName')"
					:show-overflow-tooltip="true"
					:width="180"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="code"
					:label="$t('searchUserProfit.alarmCode')"
					:align="'center'"
					:width="105"></el-table-column>
				<el-table-column
					prop="orderCount"
					:label="$t('machineOrder.orderCount')"
					:align="'center'"
					:width="105"></el-table-column>
				<el-table-column
					prop="orderRefundCount"
					:label="$t('machineOrder.orderRefundCount')"
					:align="'center'"
					:width="180"></el-table-column>
				<el-table-column
					prop="allFaultNum"
					:label="$t('machineOrder.allAlarmNum')"
					:align="'center'"
					:width="150"></el-table-column>
				<el-table-column
					prop="todayFaultNum"
					:label="$t('machineOrder.todayAlarmNum')"
					:show-overflow-tooltip="true"
					:width="160"
					:align="'center'"></el-table-column>
				<el-table-column
					fixed="right"
					:label="$t('common.operate')"
					:align="'center'"
					:width="120">
					<template slot-scope="scope">
						<el-button
							type="primary"
							icon="el-icon-view"
							size="mini"
							@click="handleViewDetail(scope.row)"
							style="padding: 7px"
							>{{ $t("machineOrder.lookxq") }}</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@size-change="sizeChange"
				@current-change="currentChange"></el-pagination>
		</div>
		<!-- 弹出详情 -->
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="$t('machineOrder.lookxq')"
			:visible.sync="dialogTableVisible"
			:width="'70%'">
			<el-table
				v-loading="xqloading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="detailData"
				:border="true">
				<el-table-column
					prop="code"
					:show-overflow-tooltip="true"
					:label="$t('searchUserProfit.alarmCode')"
					:width="120"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="info"
					:show-overflow-tooltip="true"
					:label="$t('machineOrder.alarmInfo')"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="userName"
					:show-overflow-tooltip="true"
					:label="$t('machineOrder.userName')"
					:width="200"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="equipmentNo"
					:show-overflow-tooltip="true"
					:label="$t('machineOrder.equipmentNo')"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="orderNumber"
					:show-overflow-tooltip="true"
					:label="$t('userMachineAlarm.orderNum')"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="payState"
					:show-overflow-tooltip="true"
					:label="$t('searchOrder.payState')"
					:align="'center'"
					:formatter="payState"
					:width="150"></el-table-column>
				<el-table-column
					prop="createTime"
					:formatter="(row) => $formatDate(row.createTime)"
					:show-overflow-tooltip="true"
					:label="$t('machineOrder.ordertime')"
					:align="'center'"
					:width="160"></el-table-column>
			</el-table>
			<el-pagination
				background
				layout="prev, pager, next"
				:current-page="xqpage.pageIndex"
				:total="xqpage.totalSize"
				:page-size="xqpage.pageSize"
				@current-change="currentXqChange"></el-pagination>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "WarnStatistics",
	data() {
		return {
			AdverStatisticsList: [],
			search: {
				userName: "",
				nickName: "",
				equipmentNo: "",
				equipmentName: "",
				alarmCode: "",
				startTime: "",
				endTime: "",
			},
			dateTime: [],
			page: {
				pageSize: 10,
				pageIndex: 1,
				totalSize: 0,
			},
			loading: false,
			dialogTableVisible: false,
			xqloading: false,
			xqsearch: {
				equipmentNo: "",
				alarmCode: "",
			},
			xqpage: {
				pageSize: 10,
				pageIndex: 1,
				totalSize: 0,
			},
			detailData: [],
			payStateList: [],
		};
	},
	mounted() {
		let _self = this;
		if (_self.dateTime.length < 1) {
			_self.getDefault();
		}
		_self.listPayState();
		_self.currentChange();
	},
	methods: {
		getDefault() {
			let _self = this;
			//  var today = _self.getTime(new Date(new Date().toLocaleDateString()));
			var startday = "";
			var endday = "";
			for (var j = 0; j <= 30; j++) {
				let thirtyDays =
					new Date(new Date().toLocaleDateString()).getTime() -
					j * 3600 * 24 * 1000;
				thirtyDays = _self.getTime(thirtyDays);
				if (j == 0) {
					endday = thirtyDays;
				} else if (j == 6) {
					startday = thirtyDays;
				}
			}
			_self.search.startTime = startday + " 00:00:00";
			_self.search.endTime = endday + " 23:59:59";
			_self.dateTime = [
				new Date(_self.search.startTime),
				new Date(_self.search.endTime),
			];
		},
		getTime(nS) {
			//  获取一个时间对象
			var date = new Date(nS);
			//  获取完整的年份(4位,1970)
			let y = date.getFullYear();
			//  获取月份(0-11,0代表1月,用的时候记得加上1)
			let m =
				date.getMonth() + 1 < 10
					? "0" + (date.getMonth() + 1)
					: date.getMonth() + 1;
			//  获取日(1-31)
			let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
			return y + "-" + m + "-" + d;
		},
		listPayState() {
			this.$api.dict("gp_pay_state").then(res => {
				if (res.code === 0) {
					this.payStateList = res.data;
				}
			});
		},
		// 格式化订单状态内容
		payState(row) {
			return this.$cloud.getDictLabel(this.payStateList, row.payState);
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.Statistics.alarmRecord, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.AdverStatisticsList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		onSubmit() {
			this.currentChange();
		},
		resetSearch(formName) {
			this.$refs[formName].resetFields();
			// 这个只是清除了表单数据，对象并没有重新赋值，所以调用下面的方法赋空值
			this.$toolUtil.clearForm(this.search);
			this.getDefault();
			this.currentChange();
		},
		handleViewDetail(row) {
			let _self = this;
			_self.xqsearch.equipmentNo = row.equipmentNo;
			_self.xqsearch.code = row.code;
			_self.currentXqChange();
			_self.dialogTableVisible = true;
		},
		currentXqChange(pageIndex) {
			this.xqloading = true;
			this.xqpage.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.xqsearch, this.xqpage);
			this.$api
				.request(this.$url.Statistics.alarmRecordPage, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.detailData = res.data.records;
						this.xqpage.totalSize = parseInt(res.data.total);
					}
					this.xqloading = false;
				})
				.catch(() => {
					this.xqloading = false;
				});
		},
	},
};
</script>

<style scoped></style>
